import React from "react";
import { Link } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { getCopyrightText } from "@components/Footer/utils/getCopyright";
import { useTranslation } from "react-i18next";
import { ENV } from "@config/env";

export const Footer: React.FC = () => {
	const { t } = useTranslation();

	return (
		<footer className="bg-white border-t ml-72">
			{/* Footer Links */}
			<div className="py-4 px-8 flex items-center justify-between text-sm">
				<div className="text-gray-500">{getCopyrightText(t("psdaCommon.footer.copyright"), t("psdaCommon.common.projectTitle"))}{ENV.VERSION && <span className="ml-2 text-gray-400">{ENV.VERSION}</span>}</div>
				<div className="space-x-2">
					<Link to={BROWSER_ROUTES.PRIVACY_POLICY} className="text-accent hover:text-accent-hover hover:underline">
						{t("psdaCommon.footer.privacyPolicy")}
					</Link>
					<span className="text-gray-400">|</span>
					<Link to={BROWSER_ROUTES.FAQ} className="text-accent hover:text-accent-hover hover:underline">
						FAQ
					</Link>
				</div>
			</div>
		</footer>
	);
};
